export const TICKET_ROLE_VIEW = {
  ADMIN: "admin",
  SALE: "sale",
};

export const TICKET_TYPE_FILTER_ALL = 0;

export const TICKET_TYPE_OPTIONS = [
  { value: TICKET_TYPE_FILTER_ALL, label: "Tất cả" },
  { value: 1, label: "Gửi" },
  { value: 2, label: "Nhận" },
];

export const TICKET_SOURCE_OPTIONS = [
  { value: "RUNNER", label: "Runner / Chành xe" },
  { value: "TRANSPORT", label: "Đơn vị vận chuyển" },
];

export const TICKET_DIRECTION_OPTIONS = [
  { value: "SEND", label: "Gửi" },
  { value: "RECEIVE", label: "Nhận" },
];

export const TICKET_STATUS_NEW = "NEW";
export const TICKET_STATUS_SEND_TO_SALE = "SEND_TO_SALE";
export const TICKET_STATUS_PENDING = "PENDING";
export const TICKET_STATUS_PROCESSING = "PROCESSING";
export const TICKET_STATUS_COMPLETED = "COMPLETED";
export const TICKET_STATUS_DUPLICATE = "DUPLICATE";
export const TICKET_STATUS_SKIPPED = "SKIPPED";
export const TICKET_STATUS_CANCELLED = "CANCELLED";

export const TICKET_STATUS_OPTIONS = [
  { key: TICKET_STATUS_NEW, label: "Tạo mới", color: "info" },
  { key: TICKET_STATUS_SEND_TO_SALE, label: "Gửi sale", color: "primary" },
  { key: TICKET_STATUS_PENDING, label: "Tạm ngưng", color: "dark" },
  { key: TICKET_STATUS_PROCESSING, label: "Đang xử lý", color: "warning" },
  { key: TICKET_STATUS_COMPLETED, label: "Hoàn thành", color: "success" },
  { key: TICKET_STATUS_DUPLICATE, label: "Trùng mã", color: "warning" },
  { key: TICKET_STATUS_SKIPPED, label: "Bỏ qua", color: "secondary" },
  { key: TICKET_STATUS_CANCELLED, label: "Hủy bỏ", color: "danger" },
];

export const TICKET_HISTORY_ACTION_CREATE = "CREATE";
export const TICKET_HISTORY_ACTION_SEND_TO_SALE = "SEND_TO_SALE";
export const TICKET_HISTORY_ACTION_PROCESSING = "PROCESSING";
export const TICKET_HISTORY_ACTION_SKIP = "SKIP";
export const TICKET_HISTORY_ACTION_UPDATE = "UPDATE";
export const TICKET_HISTORY_ACTION_COMPLETE = "COMPLETE";
export const TICKET_HISTORY_ACTION_DUPLICATE = "DUPLICATE";
export const TICKET_HISTORY_ACTION_CANCELLED = "CANCELLED";

export const TICKET_HISTORY_ACTION_OPTIONS = [
  { key: TICKET_HISTORY_ACTION_CREATE, label: "Tạo mới" },
  { key: TICKET_HISTORY_ACTION_SEND_TO_SALE, label: "Gửi sale" },
  { key: TICKET_HISTORY_ACTION_PROCESSING, label: "Đang xử lý" },
  { key: TICKET_HISTORY_ACTION_SKIP, label: "Bỏ qua" },
  { key: TICKET_HISTORY_ACTION_UPDATE, label: "Cập nhật" },
  { key: TICKET_HISTORY_ACTION_COMPLETE, label: "Hoàn thành" },
  { key: TICKET_HISTORY_ACTION_DUPLICATE, label: "Trùng mã" },
  { key: TICKET_HISTORY_ACTION_CANCELLED, label: "Hủy bỏ" },
];

export function normalizeTicketStatusKey(status) {
  if (status === "SENT_SALE") {
    return TICKET_STATUS_SEND_TO_SALE;
  }
  if (status === "DONE") {
    return TICKET_STATUS_COMPLETED;
  }
  return status ?? "";
}

export function resolveSendToSaleOrderRefCode(_ticket, orderRefCode) {
  const normalized = typeof orderRefCode === "string" ? orderRefCode.trim() : "";

  return normalized !== "" ? normalized : undefined;
}

export function normalizeReceiveBusOrderRefCode(value) {
  const normalized = typeof value === "string" ? value.trim() : "";

  return normalized !== "" ? normalized : undefined;
}

export function resolveTicketDisplayCode(ticket) {
  return String(ticket?.code ?? "").trim();
}

export function buildSendToSalePayload({
  ticket_id,
  type_id,
  assignees,
  note,
  resource_ids,
  order_ref_code,
  receive_bus_order_ref_code,
}) {
  const payload = { ticket_id };

  const normalizedTypeId = Number(type_id);
  if (Number.isInteger(normalizedTypeId) && normalizedTypeId > 0) {
    payload.type_id = normalizedTypeId;
  }

  if (Array.isArray(assignees) && assignees.length > 0) {
    payload.assignees = assignees;
  }

  const normalizedNote = String(note ?? "").trim();
  if (normalizedNote !== "") {
    payload.note = normalizedNote;
  }

  if (Array.isArray(resource_ids) && resource_ids.length > 0) {
    payload.resource_ids = resource_ids;
  }

  const normalizedOrderRefCode = String(order_ref_code ?? "").trim();
  if (normalizedOrderRefCode !== "") {
    payload.order_ref_code = normalizedOrderRefCode;
  }

  const normalizedReceiveBusRef = String(receive_bus_order_ref_code ?? "").trim();
  if (normalizedReceiveBusRef !== "") {
    payload.receive_bus_order_ref_code = normalizedReceiveBusRef;
  }

  return payload;
}

export const TICKET_STATUS_TERMINAL = [
  TICKET_STATUS_COMPLETED,
  TICKET_STATUS_CANCELLED,
];

export const TICKET_STATUS_NO_ACTION = [
  ...TICKET_STATUS_TERMINAL,
  TICKET_STATUS_PROCESSING,
];

export const TICKET_ROW_ACTION_STATUSES = [
  TICKET_STATUS_NEW,
  TICKET_STATUS_SEND_TO_SALE,
];

export const TICKET_CREATE_ORDER_VISIBLE_STATUSES = [TICKET_STATUS_SEND_TO_SALE];

export function getTicketLockResponseBody(response) {
  return response?.data ?? {};
}

export function isTicketLockSuccessful(response) {
  return getTicketLockResponseBody(response)?.success === true;
}

export function getTicketLockErrorMessage(response, fallback = "") {
  const message = String(getTicketLockResponseBody(response)?.message ?? "").trim();

  return message || fallback;
}

export function openDeferredPopup() {
  const popup = window.open("about:blank", "_blank");

  return {
    isOpened: Boolean(popup),
    assignUrl(url) {
      if (!popup || popup.closed) {
        return;
      }
      popup.opener = null;
      popup.location.href = url;
      popup.focus?.();
    },
    close() {
      if (popup && !popup.closed) {
        popup.close();
      }
    },
  };
}

export function getTicketSendToSaleResponseBody(response) {
  return response?.data ?? {};
}

export function isTicketSendToSaleSuccessful(response) {
  return getTicketSendToSaleResponseBody(response)?.success === true;
}

export function getTicketSendToSaleErrorMessage(response, fallback = "") {
  const message = String(
    getTicketSendToSaleResponseBody(response)?.message ?? ""
  ).trim();

  return message || fallback;
}

export const ADMIN_CANCEL_TICKET_VISIBLE_STATUSES = TICKET_STATUS_OPTIONS
  .map(item => item.key)
  .filter(status => !TICKET_STATUS_NO_ACTION.includes(status));

export const SEND_TO_SALE_VISIBLE_STATUSES = TICKET_STATUS_OPTIONS.map(
  item => item.key
).filter(status => !TICKET_STATUS_NO_ACTION.includes(status));

export const getDefaultTicketStatusFilterValues = () =>
  TICKET_STATUS_OPTIONS.map(item => item.key).filter(
    key => !TICKET_STATUS_TERMINAL.includes(key)
  );

export const TICKET_SALE_HIDDEN_STATUSES = [
  TICKET_STATUS_NEW,
  TICKET_STATUS_DUPLICATE,
  TICKET_STATUS_SKIPPED,
  TICKET_STATUS_PENDING,
  TICKET_STATUS_CANCELLED,
];

export const TICKET_SALE_DEFAULT_STATUS_FILTER_VALUES = [
  TICKET_STATUS_SEND_TO_SALE,
  TICKET_STATUS_PROCESSING,
];

export const TICKET_SALE_VISIBLE_STATUSES = TICKET_STATUS_OPTIONS.map(
  item => item.key
).filter(key => !TICKET_SALE_HIDDEN_STATUSES.includes(key));

export const TICKET_SALE_FILTER_STATUS_OPTIONS = TICKET_STATUS_OPTIONS.filter(
  item => !TICKET_SALE_HIDDEN_STATUSES.includes(item.key)
);

export const getSaleDefaultTicketStatusFilterValues = () => [
  ...TICKET_SALE_DEFAULT_STATUS_FILTER_VALUES,
];

export const resolveSaleTicketStatusFilter = (statuses = []) => {
  const normalized = (
    Array.isArray(statuses) ? statuses : statuses ? [statuses] : []
  )
    .map(normalizeTicketStatusKey)
    .filter(key => TICKET_SALE_VISIBLE_STATUSES.includes(key));

  if (normalized.length > 0) {
    return normalized;
  }

  return [...TICKET_SALE_VISIBLE_STATUSES];
};

export const isTicketStatusHiddenForSale = status =>
  TICKET_SALE_HIDDEN_STATUSES.includes(normalizeTicketStatusKey(status));

export function stripTicketTableColumnFilters(columnFilter = {}) {
  const next = {};
  Object.keys(columnFilter).forEach(key => {
    if (!isTicketTableColumnFilterKey(key)) {
      next[key] = columnFilter[key];
    }
  });
  return next;
}

function isTicketTableColumnFilterKey(key) {
  return /filter\[(code|name|maker_date|order_ref_code|receive_bus_order_ref_code)\](\[like\]|\[(eq|neq|gt|gte|lt|lte)\])?/.test(
    key
  );
}

/**
 * @param {Record<string, unknown>} [columnFilter]
 * @returns {Record<string, unknown>}
 */
export function normalizeTicketListColumnFilter(columnFilter = {}) {
  /** @type {Record<string, unknown>} */
  const next = { ...columnFilter };
  const likeValue = next["filter[display_name][like]"];
  const bracketValue = next["filter[display_name]"];

  delete next["filter[display_name][like]"];
  delete next["filter[display_name]"];

  const raw =
    likeValue !== undefined && likeValue !== null ? likeValue : bracketValue;
  const trimmed = typeof raw === "string" ? raw.trim() : String(raw ?? "").trim();

  if (trimmed !== "") {
    next.display_name = trimmed;
  } else {
    delete next.display_name;
  }

  return next;
}

/**
 * @returns {{
 *   page: number,
 *   sizePerPage: number,
 *   sort: string,
 *   keywords: string,
 *   run: boolean,
 *   columnFilterKeep: Record<string, unknown>,
 *   columnFilter: Record<string, unknown>,
 * }}
 */
export const getInitTicketParams = (isSale = false) => {
  return {
    page: 1,
    sizePerPage: 10,
    sort: "-maker_date",
    keywords: "",
    run: true,
    columnFilterKeep: {},
    columnFilter: {
      "filter[status][in]": isSale
        ? getSaleDefaultTicketStatusFilterValues()
        : getDefaultTicketStatusFilterValues(),
    },
  };
};

export const resolveTicketRoleView = roles => {
  const isLogAdmin = roles.some(role => role.includes("LOG_ADMIN"));
  if (isLogAdmin) {
    return TICKET_ROLE_VIEW.ADMIN;
  }

  return TICKET_ROLE_VIEW.SALE;
};

export const formatTicketStatus = status => {
  const key = normalizeTicketStatusKey(status);
  return (
    TICKET_STATUS_OPTIONS.find(item => item.key === key) || {
      key: key || "",
      label: key || "",
      color: "secondary",
    }
  );
};

export const formatTicketHistoryAction = action => {
  const key = String(action || "").trim().toUpperCase();
  return (
    TICKET_HISTORY_ACTION_OPTIONS.find(item => item.key === key)?.label || key || "—"
  );
};

export const TICKET_SALE_NAMES_PREVIEW_MAX = 3;

export function getTicketSaleNamesList(row) {
  const assignees = row?.assignees;

  if (!Array.isArray(assignees)) {
    return [];
  }

  return assignees
    .map(item => String(item?.name ?? "").trim())
    .filter(Boolean);
}

export function getTicketSaleNamesFullText(row) {
  return getTicketSaleNamesList(row).join(", ");
}

export function formatTicketSaleNamesPreview(
  names,
  maxVisible = TICKET_SALE_NAMES_PREVIEW_MAX
) {
  if (!Array.isArray(names) || names.length === 0) {
    return { text: "", fullText: "", isTruncated: false };
  }

  const fullText = names.join(", ");

  if (names.length <= maxVisible) {
    return { text: fullText, fullText, isTruncated: false };
  }

  return {
    text: `${names.slice(0, maxVisible).join(", ")}...`,
    fullText,
    isTruncated: true,
  };
}

export function extractTicketUploadResourceId(res) {
  return Number(res?.data?.id);
}

export function mapTicketTypeOptions(body) {
  const items = body?.items;

  if (!Array.isArray(items)) {
    return [];
  }

  return items
    .map(row => ({
      value: Number(row.id),
      label: String(row.name ?? ""),
    }))
    .filter(option => Number.isFinite(option.value) && option.label);
}
